import PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import ReactPlayer from 'react-player'
import {get} from "lodash";


const ReactPlayerComponent = ({data, sliderClassName, VideoPlay}) => {
    const [leftImageSplace, setLeftImageSplace] = useState(0)
    const [rightImageSplace, setRightImageSplace] = useState(0)
    const [videoSize] = useState(() => {
        const tempSize = get(data, "videoSize", "720px");

        return !(tempSize.indexOf("x") !== -1) && tempSize + "x"
    })
    useEffect(() => {
        if (Number(data.innerImageLeftRightSpace) > 0) {
          if (data.popupImageAlign === 'right') {
            setRightImageSplace(data.innerImageLeftRightSpace)
          } else {
            setLeftImageSplace(data.innerImageLeftRightSpace)
          }
        }
      }, [data.innerImageLeftRightSpace, data.popupImageAlign])

    const DivNaviGate = {
        cursor: "pointer",
        background: "#000",
        zIndex: "1",
        position: "absolute",
        height: "100%",
        left: "0",
        top: "0",
        opacity: "0",
    }

    return (
        <>
            {!!data.videoLink && !!data.videoNavigate && 
                <div
                    onClick={() => {
                        window.open(data.videoNavigate, "_blank");
                    }}
                    className="w-100"
                    style={DivNaviGate}
                ></div>
            }
            {data.popupImage !== undefined && data.popupImage !== "" && (
                <img className="animated" src={data.popupImage} style={{
                    position: "absolute", maxHeight: "100%", width: " auto", right: 0, maxWidth: "50%", top: "50%", marginLeft: leftImageSplace + "%", marginRight: rightImageSplace + "%", transform: "translateY(-50%)"
                }} alt=""/>
            )}   
            <ReactPlayer
                url={data.videoLink}
                className="w-100"
                playing={VideoPlay}
                height={videoSize}
                width={videoSize}
                playsinline
                muted
                loop={true}
                style={{
                    border: data.videoBorder === "true" ? "1px solid #080808" : "0px solid", padding: `0 ${data["background_image_size"]}px`, background: `${data.bgColor}` , objectFit: "fill", aspectRatio: "16/7"
                }}
            />
        </>
    );
};

ReactPlayerComponent.propTypes = {
    data: PropTypes.object,
    sliderClassName: PropTypes.string,
};


export default ReactPlayerComponent;
